import { Button, Select, Space, Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import { useTableUrlState } from '@/shared/ui/table/useTableUrlState'
import { ACTIVE_FILTER, ACTIVE_ONLY, REGION_FILTER, SHOW_ALL } from './geoApi'
import { useRegionOptions } from './useGeoOptions'

/**
 * ⚠️ Holat URL'da (`useTableUrlState`), o'z `useState` ida EMAS: ustun
 * sarlavhasidagi voronka ham AYNI holatni o'qiydi, ya'ni ikkitasi
 * bir-biriga zid bo'lib qolmaydi.
 */
export function GeoFilterBar({ withRegion = false }: { withRegion?: boolean }) {
  const { t } = useTranslation()
  const { state, patch } = useTableUrlState()
  const regions = useRegionOptions(false, withRegion)

  /**
   * ⚠️ Tanlanmagan = `ACTIVE_ONLY`, bo'sh emas (egasi qarori 2026-08-20).
   *
   * Tanlagich `allowClear` EMAS va DOIM qiymat ko'rsatib turadi: bo'sh
   * maydon «filtr yo'q» deb o'qilardi, ro'yxat esa aslida torayib
   * turgan bo'lardi — nofaol viloyatlar ko'rinmayotganini operator
   * hech qayerdan bilmasdi.
   */
  const activeValue = state.filters[ACTIVE_FILTER]?.[0] ?? ACTIVE_ONLY
  const regionValue = state.filters[REGION_FILTER]?.[0]
  // Sukut holat nishonda SANALMAYDI — u yashiringan filtr emas, ekranda turibdi
  const count = [regionValue, activeValue === ACTIVE_ONLY ? undefined : activeValue].filter(Boolean)
    .length

  const setFilter = (key: string, value: string | undefined) => {
    patch({ page: 1, filters: { ...state.filters, [key]: value ? [value] : [] } })
  }

  return (
    <Space wrap size="small">
      {withRegion ? (
        <Select
          allowClear
          showSearch
          optionFilterProp="label"
          style={{ minWidth: 200 }}
          placeholder={t('geo.region')}
          loading={regions.isPending}
          value={regionValue}
          onChange={(v: string | undefined) => setFilter(REGION_FILTER, v)}
          options={regions.options.map((r) => ({
            value: r.id,
            label: r.active ? r.name : `${r.name} (${t('geo.inactive')})`,
          }))}
        />
      ) : null}
      {/*
        ⚠️ IKKI TANLOV, VA UCHINCHISI YO'Q. Kontrakt `activeOnly`
        bayrog'ini beradi, «faqat nofaollar» degan so'rov esa serverda
        MAVJUD EMAS. Uni mijozda yasash sahifalangan ro'yxatda faqat
        joriy sahifani toraytirardi — ya'ni «nofaol yo'q» degan javob
        YOLG'ON bo'lardi.

        Shuning uchun nofaolni ko'rish yo'li — «Barcha holatlar»: u
        serverga boradi va butun ro'yxat ustidan ishlaydi.
      */}
      <Select
        style={{ minWidth: 170 }}
        aria-label={t('geo.status')}
        value={activeValue}
        onChange={(v: string) => setFilter(ACTIVE_FILTER, v)}
        options={[
          { value: ACTIVE_ONLY, label: t('geo.activeOnly') },
          { value: SHOW_ALL, label: t('dataTable.stateAll') },
        ]}
      />
      {count > 0 ? (
        <Space size={4}>
          <Tag color="blue">{t('dataTable.activeFilters', { count })}</Tag>
          <Button size="small" type="link" onClick={() => patch({ page: 1, filters: {} })}>
            {t('dataTable.clearFilters')}
          </Button>
        </Space>
      ) : null}
    </Space>
  )
}
